import { ReactNode } from 'react';

import { usePermissionsContext } from '../context/permissionsContext';

import { TermsAcceptanceModal } from './TermsAcceptanceModal';

const AppGates = ({ children }: { children: ReactNode }) => {
  const { userData } = usePermissionsContext();
  const showTermsModal = !!userData?.show_super_pollutants_terms_modal;

  return (
    <>
      {children}
      <TermsAcceptanceModal open={showTermsModal} />
    </>
  );
};

export { AppGates };
